import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LoadLevel } from '@/shared/api/protocol-ts/model/dto_system_load_pb';
import { SliceName } from '@/shared/config';

import { ReportPipelineLevels } from '../config';

type HighLoadState = {
  // effective load levels of the upload processing queues, pushed by PatientProfileStream
  uploadKafkaLevel: LoadLevel;
  uploadCBCTLevel: LoadLevel;
  // effective pipeline load levels per report pending in the pipelines queue
  reportLevels: Record<string, ReportPipelineLevels>;
};

const initialState: HighLoadState = {
  uploadKafkaLevel: LoadLevel.LoadLevel_InvalidValue,
  uploadCBCTLevel: LoadLevel.LoadLevel_InvalidValue,
  reportLevels: {},
};

export const highLoadSlice = createSlice({
  name: SliceName.highLoad,
  initialState,
  reducers: {
    setUploadLevels: (
      state,
      action: PayloadAction<{
        uploadKafkaLevel: LoadLevel;
        uploadCBCTLevel: LoadLevel;
      }>,
    ) => {
      state.uploadKafkaLevel = action.payload.uploadKafkaLevel;
      state.uploadCBCTLevel = action.payload.uploadCBCTLevel;
    },

    setReportLevels: (
      state,
      action: PayloadAction<{ reportID: string; levels: ReportPipelineLevels }>,
    ) => {
      state.reportLevels[action.payload.reportID] = action.payload.levels;
    },

    reset: () => initialState,
  },
});

export const highLoadReducer = highLoadSlice.reducer;
export const actions = highLoadSlice.actions;
